export const modList = [
    {   
        title: `Tim's FloppyDisk`,
        game: 'Lethal Company',
        desc: 'A mod to add floppydisks as a scrap type, including a few different colors',
        link: 'https://thunderstore.io/c/lethal-company/p/Neale69/Tims_FloppyDisk/'
    },
    {   
        title: `Castle Tower`,
        game: 'Pseudoregalia',
        desc: 'A small custom map with hard platforming',
        link: 'https://www.nexusmods.com/pseudoregalia/mods/94'
    },
]